/* eslint-disable @typescript-eslint/no-explicit-any */
import { InMemoryCache } from '@apollo/client'

const MERGEABLE_QUERIES = ['invoices', 'deliveries']

/**
 * Comstruct Apollo Cache
 * @category General
 */
export function ComstructApolloCache(): InMemoryCache {
  const mergeObject = {
    keyArgs: ['where', 'order_by'],
    merge: (existing: any[], incoming: any[]) => {
      existing = existing ?? []
      const merged = existing.concat(
        /**
         *  Filter out duplicates
         *  A sample entry of this type: {__ref: "Invoice:1"}
         */
        incoming.filter(e => !existing.some(m => m.__ref === e.__ref))
      )
      return merged
    },
  }
  const mergeableQueries = MERGEABLE_QUERIES.reduce(
    (acc, query) => {
      acc[query] = mergeObject
      return acc
    },
    {} as Record<string, any>
  )
  return new InMemoryCache({
    typePolicies: { Query: { fields: mergeableQueries } },
  })
}
